import { useState } from "react";
import { useDotLegalSnackbar } from "@dotlegal/dotlegal-ui-components";
import { UpdateSavedViewDialogProps } from "./UpdateSavedViewDialog";
import { useTranslation } from "../../../../localization/useTranslation";
import { isNullOrWhitespace } from "../../../stringOperations";
import { Result } from "../../../api/result";
import { put } from "../../../api/apiShared.ts";
import { useDotLegalMutation } from "@common/hooks/dotLegalReactQuery";

export function useUpdateSavedViewHook(props: UpdateSavedViewDialogProps) {
    const snackbar = useDotLegalSnackbar();

    const { translateString } = useTranslation();

    const [viewName, setViewName] = useState(props.view.name);
    const [showError, setShowError] = useState(false);

    const updateMutation = useDotLegalMutation(update);
    const onUpdateView = () => {
        if (isNullOrWhitespace(viewName)) {
            setShowError(true);
            return;
        }

        updateMutation.mutateAsync(
            { id: props.view.id, viewName },
            {
                onSuccess: (response: Result<string>) => {
                    snackbar.show(translateString("viewUpdated"));
                    props.onViewUpdated();
                },
            }
        );
    };

    return {
        viewName,
        setViewName,
        showError,
        onUpdateView,
        inProgress: updateMutation.isLoading,
    };

    async function update({ id, viewName }: { id: string; viewName: string }) {
        return await put<string>(`/saved-views/${id}/change-name`, viewName);
    }
}
